<app-top-navbar [title]="'profile-form.password' | translate">
  <a class="top-bar-link" [routerLink]="['../..', 'profile', 'edit']">
    <i class="icon icon-chevron-left"></i>
  </a>
</app-top-navbar>
<div class="wrapper page-change-password">
  <app-loyalty-club-header/>
  <div class="content">
    <form [formGroup]="form" (submit)="submit()" [class.submitted]="isSubmitted">
      <div
          [class]="{'is-focused': $any(current_password).isFocused, 'has-error': form.controls.current_password.errors }"
          class="form-group label-static is-empty">
        <label class="control-label">
          <span>{{ 'profile-form.current_password' | translate }}</span>
          <span class="required">*</span>
        </label>
        <input class="form-control"
               formControlName="current_password"
               type="password"
               #current_password
               appFocusable
               (onFocusChange)="$any(current_password).isFocused = $event">
        @if (formErrors.current_password || form.get('current_password')?.errors) {
          <app-input-errors
              [errorsForField]="formErrors.current_password"
              [translationKey]="'errors.profile-form.current_password'"/>
        }
      </div>
      <app-password formControlName="new_password"/>
      <div class="form-group text-center">
        <button type="button" (click)="submit()" class="btn btn-raised btn-primary">
          {{ 'profile-form.change_password'  | translate }}
        </button>
      </div>
    </form>
  </div>
  <app-loyalty-club-footer/>
</div>
